module.exports = {
          srcSet: "/_next/static/images/img-sports@2x-160-221f78d6f77b6b09d3fd0b164bcd6ee4.webp"+" 160w"+","+"/_next/static/images/img-sports@2x-292-af7672deffcf765bc53629f0b129f8e0.webp"+" 292w",
          images:[ {path: "/_next/static/images/img-sports@2x-160-221f78d6f77b6b09d3fd0b164bcd6ee4.webp",width: 160,height: 137},{path: "/_next/static/images/img-sports@2x-292-af7672deffcf765bc53629f0b129f8e0.webp",width: 292,height: 250}],
          src: "/_next/static/images/img-sports@2x-160-221f78d6f77b6b09d3fd0b164bcd6ee4.webp",
          toString:function(){return "/_next/static/images/img-sports@2x-160-221f78d6f77b6b09d3fd0b164bcd6ee4.webp"},
          placeholder: undefined,
          width: 160,
          height: 137
      }